import { useReward } from '@/contexts/reward-context';
import { useEffect, useState } from 'react';
import { Award, AwardType, Event, Reward, RewardScene, RewardType } from '@/types';
import { TagIcon, TickIcon } from '../svg-icons';
import { replaceResource } from '@/utils';
import { RewardModalWrapper } from '@/components/reward-modal-wrapper';

export const SignInResultPopup = () => {

	const {
		labels,
		planInfo,
		goToEvent,
		setRewardScene,
		onKafkaSet
	} = useReward();
	
	const [signInEvents, setSignInEvents] = useState<Event[]>([]);

	useEffect(() => {
		const signInEvents = planInfo?.Rewards.find((rewardData: Reward): boolean => rewardData.RewardType === RewardType.SignIn)?.Events ?? [];

		setSignInEvents(signInEvents);
	}, []);

	const goToBetting = () => {
		onKafkaSet({
			type: 4,
			action: 8
		});
		
		if (goToEvent) {
			goToEvent(RewardType.Betting, 1, false);
		}
	}

	const gotoShop = () => {
		onKafkaSet({
			type: 4,
			action: 9
		});
		setRewardScene(RewardScene.Shop);
	}

	const todayEvent = signInEvents.slice().reverse().find(event => event.CompleteDate);
	const dayCount = todayEvent?.Level;
	const spinGetCoins = todayEvent?.Awards?.find(award => award.AwardType == AwardType.SpinGame)?.Amount ?? 0;
	const vouchers = todayEvent?.Awards?.filter(award => [AwardType.OddsBooster, AwardType.FreeRiskBet, AwardType.NewRiskFreeBet].includes(award.AwardType)) ?? [];

	let status = '';

	if (vouchers && vouchers.length) {
		status = 'has-voucher';
	} else if (spinGetCoins == 0) {
		status = 'is-signed';
	}

	return (
		<RewardModalWrapper>
			<section className="reward-sign">
				<div className="reward-sign__container">
					<div className="reward-sign__header">
						{
							/**
							 * [data-status=""]：僅有 point（移除 voucher）
							 * [data-status="has-voucher"]：point + voucher
							 * [data-status="is-signed"]：今天已簽到（移除 point + voucher）
							 */
						}
						<div className="reward-sign__title-group" data-status={status}>
							<div className="reward-sign__title">{spinGetCoins ? labels?.lbl_RPCongrats : labels?.lbl_RPTodayCompleted}</div>
							<div className="reward-sign-receive">
								{
									spinGetCoins ? 
										<div className="reward-sign-receive__point">
											<span className="reward-sign-receive__icon">
												<i className="reward-iconcolor-shop-coin" />
											</span>
											<span className="reward-sign-receive__amount">{spinGetCoins}</span>
										</div> : null
								}
								{
									vouchers.map((voucher, index) => {
										return (
											<div key={index} className="reward-sign-receive__voucher">
												<span className="reward-sign-receive__icon">
													{
														{
															[AwardType.OddsBooster]: <i className="reward-icon-voucher-oddsboost" />,
															[AwardType.FreeRiskBet]: <i className="reward-icon-voucher-shield" />,
															[AwardType.NewRiskFreeBet]: <i className="reward-icon-voucher-shield" />
														}[voucher.AwardType]
													}
												</span>
												<span className="reward-sign-receive__amount">{voucher.Amount}</span>
											</div>
										)
									})
								}
							</div>
						</div>
					</div>
					<div className="reward-sign__body">
						<div className="reward-sign__text">
							<div className="reward-sign__text-small">{replaceResource(labels?.lbl_RPCheckInForDays ?? '', `${dayCount}`)}</div>
							{
								vouchers && vouchers.length ?
									<div className="reward-sign__text-strong">{labels?.lbl_RPCheckInFor7Days}</div> : null
							}
						</div>
						<div className="reward-sign-daily">
							{
								signInEvents.map(event => {
									return (
										<DailySignInResult
											key={event.Level}
											event={event}
											isActive={event.Level == dayCount}
										/>
									);
								})
							}
						</div>
						<div className="reward-sign__text-info">{labels?.lbl_RPResetAccumulation}</div>
						<div className="reward-sign__btns">
							<div 
								className="reward-sign__btn reward-sign__btn--secondary"
								onClick={goToBetting}
							>
								<div className="reward-sign__btn-text">{labels?.lbl_RPPlaceBet}</div>
							</div>
							<div 
								className="reward-sign__btn reward-sign__btn--primary"
								onClick={gotoShop}
							>
								<div className="reward-sign__btn-text">{labels?.lbl_RPRedeemVoucher}</div>
							</div>
						</div>
					</div>
					<div className="reward-sign__footer" />
				</div>
			</section>
		</RewardModalWrapper>
	);
}

const DailySignInResult = ({
	event,
	isActive
}: {
	event: Event,
	isActive: boolean
}) => {

	const [vouchers, setVouchers] = useState<Array<Award>>([]);

	useEffect(() => {
		const voucherAwards = event.Awards?.filter(award => {
			return [AwardType.OddsBooster, AwardType.FreeRiskBet, AwardType.NewRiskFreeBet].includes(award.AwardType);
		});

		setVouchers(voucherAwards);
	}, []);

	return (
		<>
			<div className="reward-sign-daily__item" data-active={isActive}>
				{event.Level}
				<span className="reward-sign-daily__check" data-play-animation="false">
					{
						event.CompleteDate ?
							<TickIcon /> : <TagIcon />
					}
				</span>
			</div>
			{
				vouchers && vouchers.length ?
					<div className="reward-sign-daily__voucher">
						{
							vouchers.map((voucher, index) => {
								return {
									[AwardType.OddsBooster]: <i key={`${event.Level}_${index}`} className="reward-icon-voucher-oddsboost" />,
									[AwardType.FreeRiskBet]: <i key={`${event.Level}_${index}`} className="reward-icon-voucher-shield" />,
									[AwardType.NewRiskFreeBet]: <i key={`${event.Level}_${index}`} className="reward-icon-voucher-shield" />,
								}[voucher.AwardType];
							})
						}
					</div>
					: null
			}
		</>
	);
};